import Model from "./Model.js";

/**
 * Model holding the VAT rate and it's label. It also knows if it is the
 * default rate to use.
 *
 * @param {string} label - A user-visible short string to identify this VAT
 * @param {number} value - The percentage that applies, it's between 0 and 100
 * @param {boolean} isDefault - Represent if the VAT is the default for
 *   the country
 */
export default class VatRate extends Model {
	constructor({ label, value = 0, isDefault = false } = {}) {
		super(...arguments);
		this._label = label;
		this._value = value;
		this._isDefault = isDefault;
	}

	getLabel() {
		return this._label;
	}

	setLabel(label) {
		this._label = label;
	}

	getValue() {
		return this._value;
	}

	setValue(rate) {
		this._value = rate;
	}

	isDefault() {
		return !!this._isDefault;
	}

	setIsDefault(bool) {
		this._isDefault = bool;
	}

	clone() {
		return this.constructor.materialize(this.serialize(), {});
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.label = this._label;
		properties.rate = this._value;
		properties.isDefault = this._isDefault;

		return properties;
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.value = data.rate;
	}
}
